import React, { useState, useEffect, useRef } from 'react';
import { Divider } from 'primereact/divider';
import { useHistory } from 'react-router-dom';
import { AuthApiService } from '../../../services/AuthApiService';
import { Toast } from 'primereact/toast';
import { Oval } from  'react-loader-spinner'


const VerifyEmail = () => {
  const history = useHistory();
  const [passcode, setPasscode] = useState('');
  const [countDown, setCountDown] = useState(0);
  const [runTimer, setRunTimer] = useState(true);
  const [requestId, setRequestId] = useState();
  const [deviceId, setDeviceId] = useState();
  const [userName, setUserName] = useState();
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('')
  const toast = useRef(null);
  const _apiService = new AuthApiService();

  /* 
  Request another email verification link 
  https://docs.oracle.com/en/cloud/paas/identity-cloud/rest-api/op-admin-v1-meemailverifier-put.html
  {
  "email": "bjensen@example.com",
  "schemas": [
    "urn:ietf:params:scim:schemas:oracle:idcs:MeEmailVerifier"
  ],
  "id": "5fed0efce51f40b4a42b0773a65178c3"
  }
  {
    "schemas": [
      "urn:ietf:params:scim:schemas:oracle:idcs:extension:MeEmailVerifier"
    ],
    "id": "5fed0efce51f40b4a42b0773a65178c3"
  }
  */

  /* Me User Info sampel email block when an email verificaiton is pending
  -------------
  	"emails": [{
		"value": "MTTDevSupport@fdny.nyc.gov",
		"type": "home",
		"pendingVerificationData": "replace:absrao@gmail.com:primary:home",
		"secondary": false,
		"verified": true,
		"primary": true
	}],
  ---------------
  */


  useEffect(() => {
    setEmail(history.location.state.email)
    let timerId;
    if (runTimer) {
      setCountDown(60 * 10);
      timerId = setInterval(() => {
        setCountDown((countDown) => countDown - 1);
      }, 1000);
    } else {
      clearInterval(timerId);
    }
    return () => clearInterval(timerId);
  }, [runTimer]);

  useEffect(() => {
    checkPendingEmailVerification();
    if (countDown < 0 && runTimer) {
      console.log("expired");
      setRunTimer(false);
      setCountDown(0);
    }
  }, [countDown, runTimer]);

  useEffect(() => {
    if (status === 200) {
      history.push({ pathname: '/auth/email-success', state: { email: email }});
    }
  }, [status !== 200]);


  const checkPendingEmailVerification = async () => {
    const [userInfo] = await Promise.all([
      await _apiService.getMeUserInfos()
    ]);

    if(!userInfo.emails[0]?.pendingVerificationData) {
      setCountDown(0);
      // If success, navigate to email success page
      history.push({
        pathname: '/auth/email-success',
        state: {
          email: email
        },
      });
    } else {
      console.log("waiting for pending email verification to complete");
    }

  }


  const requestEmailLink = async () => {
    const emailVerifierData = {
      "email": history.location.state.email,
      "schemas": [
        "urn:ietf:params:scim:schemas:oracle:idcs:MeEmailVerifier"
      ]
    }

    const reqPass = await _apiService.requestEmailVerifier(emailVerifierData);
    if (!reqPass || reqPass.error || reqPass.status === '401') {
      if (reqPass.status === '401') {
        setMessage(reqPass.detail);
        //toast.current.show({ severity: 'error', summary: reqPass.detail, detail: 'Message Content', life: 3000 });
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: reqPass.detail,
          life: 5000
        });
      } else {
        setMessage(reqPass.error);
        // toast.current.show({ severity: 'error', summary: reqPass.error, detail: 'Message Content', life: 3000 });
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: reqPass.error,
          life: 5000
        });
      }

      return;
    } else {
      setRequestId(reqPass.id);
      setCountDown(60 * 10)
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: "Requested email verification link",
        life: 5000
      });
      // toast.current.show({ severity: 'success', summary: 'Request Send!', detail: 'Message Content', life: 3000 });
    }
  };

  const seconds = String(countDown % 60).padStart(2, 0);
  const minutes = String(Math.floor(countDown / 60)).padStart(2, 0);

  return (
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className="flex flex-column align-items-center">
          <h3>Two-step Verification</h3>
          <span>
            Two-step verification adds an additional layer of security by using a second device to verify your identity.
          </span>
          <Divider className="py-3" />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <h3 className="m-0">Let's verify your email.</h3>
          <p className='mt-5'>A verification link has been sent to your new email address: {history.location.state.email}. Please review the instructions and confirm.</p>
          <div className="loader-container">
            <Oval
              height="34"
              width="34"
              color='rgb(0, 111, 207)'
              secondaryColor='rgb(0, 111, 207)'
              ariaLabel='loading'
            />
          </div>
          <div className="flex justify-content-between align-items-center">
            <div>
              <p>
                Link expires in:{' '}
                <span style={{ color: 'red' }}>
                  {minutes}:{seconds}
                </span>
              </p>
            </div>
            <div>
              <b className="text-primary cursor-pointer" onClick={() => requestEmailLink()}>
                Resend Link
              </b>
            </div>
          </div>
          <b onClick={() => history.goBack()} className="text-primary cursor-pointer">
            Cancel
          </b>
        </div>
      </div>
      <Toast ref={toast} className="responsive-toast" />
    </div>
  );
};

export default VerifyEmail;
